import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import authApiService from "../../services/api/AuthApiService";
import authService from "../../services/AuthService";
export default {
  props: {
    phone: {
      required: true,
      type: String
    }
  },
  data: function data() {
    return {
      code: "",
      verifying: false,
      timeLeftToSendCodeAgain: 0,
      timerID: null
    };
  },
  methods: {
    login: function login() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.verifying = true;

                _this.$vs.loading();

                authApiService.verify(_this.phone, _this.code).then(function (userData) {
                  /*
                    access_token: ...
                    user: {
                      id: number
                      name: string
                      phone: string
                      privileged: boolean
                    }
                    */
                  authService.login(_objectSpread(_objectSpread({}, userData), {}, {
                    phone: _this.phone,
                    privileged: userData.privileged
                  }));

                  _this.$store.commit("auth/LOGIN");
                }).catch(function (err) {
                  var message = err.getErrorDescriptions();

                  switch (err.status) {
                    case 400:
                      message = err.error.response.data.message || err.getErrorDescriptions();
                      break;

                    case 404:
                      message = err.error.response.data.message || "کد وجود ندارد";
                      _this.code = "";
                      break;
                  }

                  _this.$vs.notify({
                    text: message,
                    color: "danger",
                    position: "bottom-center"
                  });
                }).finally(function () {
                  _this.verifying = false;

                  _this.$vs.loading.close();
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    destroyTimer: function destroyTimer() {
      if (this.timerID) clearInterval(this.timerID);
    },
    editPhone: function editPhone() {
      this.$emit("edit-phone");
    },
    sendCodeAgain: function sendCodeAgain() {
      var _this2 = this;

      this.$vs.loading();
      authApiService.login(this.phone).then(function () {
        _this2.setIntervalToSendCodeAgain();
      }).catch(function (err) {
        var message = err.getErrorDescriptions();

        switch (err.status) {
          case 403:
            message = "شما اجازه دسترسی به این پنل را ندارید";
            break;

          case 404:
            message = "شماره همراه معتبر نیست";
            break;
        }

        _this2.$vs.notify({
          text: message,
          color: "danger",
          position: "bottom-center"
        });

        if (err.status === 403) {
          _this2.phone = "";
        }
      }).finally(function () {
        _this2.$vs.loading.close();
      });
    },
    setIntervalToSendCodeAgain: function setIntervalToSendCodeAgain() {
      var _this3 = this;

      this.timeLeftToSendCodeAgain = 60;
      this.timerID = setInterval(function () {
        _this3.timeLeftToSendCodeAgain--;

        if (_this3.timeLeftToSendCodeAgain <= 0) {
          _this3.destroyTimer();
        }
      }, 1000);
    }
  },
  watch: {
    code: function code(value) {
      if (value.length === 4) {
        this.login();
      }
    }
  },
  mounted: function mounted() {
    this.setIntervalToSendCodeAgain();
  },
  destroyed: function destroyed() {
    this.destroyTimer();
  }
};